import {
  capitalizeFirstLetter,
  sluggify,
} from '../../common/functions';

L.Control.TagFilterButton = L.Control.extend({

  options: {
    header: null,
    container: null,
    storeItemSelector: null,
    onSelectionComplete: null, // the callback function for selected tags
    data: null, // the data to be used for tags popup, it can be array or function
    clearText: null, // the text of the clear button
    filterOnEveryClick: false, // if set as true the plugin do filtering operation on every click event on the checkboxes
    openPopupOnHover: false, // if set as true the popup that contains tags will be open at mouse hover time
    ajaxData: null // it can be used for remote data TODO: implement it!
  },

  map: null,
  _container: null,
  tagEl: null,
  tagSubEl: null,
  filtersHeader: null,
  clearEl: null,
  filterInfo: null,
  selectedTags: [],
  invisibles: null,
  releatedFilterButtons: null,
  layerSources: null,

  /**
   * @function: resetCaches
   * Resets marker caches
   * @param update: if send as true, the @update function is called after cleaning the cache
   * */
  resetCaches: function (update) {
    if (typeof update !== 'boolean')
      update = true;
    this.invisibles = [];
    if (update) {
      this.update();
    }
  },

  /**
   * @function: update
   * Update markers by last selected tags
   *
   * */
  update: function () {
    var filteredCount = this.layerSources.currentSource.hide.call(this, this.layerSources.currentSource);
    this.filtersCounter(filteredCount);
  },

  /**
   * @function: hasFiltered
   * returns true if any tag(s) selected otherwise false
   *
   * */
  hasFiltered: function () {
    return this.selectedTags.length > 0;
  },

  /**
   * @function: registerCustomSource
   * Register @source object for filtering markers by tags. If you want to use this function
   * you must implement @hide function.
   * @param source reference of the new marker source. It must have name and source item
   *
   * */
  registerCustomSource: function (source) {
    if (source.name && source.source && typeof source.source.hide === 'function') {
      this.layerSources.sources[source.name] = source.source;
    } else {
      throw 'Layer source is incompatible';
    }
  },

  /**
   * @function: addToReleated
   * @param other adds another linked tagFilterButton reference to releatedFilterButtons
   *
   * */
  addToReleated: function (other) {
    if (other && other instanceof L.Control.TagFilterButton && this.releatedFilterButtons.indexOf(other) == -1) {
      this.releatedFilterButtons.push(other);
      return other.addToReleated(this);
    }
    console.error("could not add tagFilterButton instance to releated");
    return false;
  },

  /**
   * @function: getInvisibles
   * @param other gets invisibles layers hiding by this plugin
   *
   * */
  getInvisibles: function () {
    return this.invisibles;
  },

  _prepareLayerSources: function () {
    this.layerSources = new Object();
    this.layerSources['sources'] = new Object();

    this.registerCustomSource({
      name: 'default',
      source: {
        hide: function () {
          var releatedLayers = [];

          for (var r = 0; r < this.releatedFilterButtons.length; r++) {
            releatedLayers = releatedLayers.concat(this.releatedFilterButtons[r].getInvisibles());
          }

          var toBeRemovedFromInvisibles = [],
            i;

          // "Fix": add var
          for (var i = 0; i < this.invisibles.length; i++) {
            if (releatedLayers.indexOf(this.invisibles[i]) == -1) {
              // "Fix": add var
              for (var j = 0; j < this.invisibles[i].options.tags.length; j++) {
                if (this.selectedTags.length == 0 || this.selectedTags.indexOf(this.invisibles[i].options.tags[j]) !== -1) {
                  this.map.addLayer(this.invisibles[i]);
                  toBeRemovedFromInvisibles.push(i);
                  break;
                }
              }
            }
          }

          while (toBeRemovedFromInvisibles.length > 0) {
            this.invisibles.splice(toBeRemovedFromInvisibles.pop(), 1);
          }

          var removedMarkers = [];
          var totalCount = 0;

          if (this.selectedTags.length > 0) {
            this.map.eachLayer(
              function (layer) {
                if (layer && layer.options && layer.options.tags) {
                  totalCount++;
                  if (releatedLayers.indexOf(layer) == -1) {
                    var found = false;
                    for (var i = 0; i < layer.options.tags.length; i++) {
                      found = this.selectedTags.indexOf(layer.options.tags[i]) !== -1;
                      if (found) {
                        break;
                      }
                    }
                    if (!found) {
                      removedMarkers.push(layer);
                    }
                  }
                }
              }.bind(this)
            );

            for (i = 0; i < removedMarkers.length; i++) {
              this.map.removeLayer(removedMarkers[i]);
              this.invisibles.push(removedMarkers[i]);
            }
          }

          return totalCount - removedMarkers.length;
        }
      }
    });
    this.layerSources.currentSource = this.layerSources.sources['default'];
  },


  initialize: function (options) {
    this.invisibles = [];
    this.releatedFilterButtons = [];
    L.Util.setOptions(this, options || {});
    this._prepareLayerSources();
  },

  /**
   * Items Events
   * */
  checkItem: function (item) {
    item.dataset.checked = "checked";
  },

  uncheckItem: function (item) {
    item.dataset.checked = "";
  },

  clickItem: function (e) {
    L.DomEvent.stop(e);
    const li = this.element;
    const context = this.context;
    if (!li.dataset.checked) {
      context.checkItem(li);
    } else {
      context.uncheckItem(li);
    }
    if (context.options.filterOnEveryClick) {
      context.filter.call(context);
    }
  },


  /**
  * Filters
  * */
  makeFiltersList: function (datas) {
    const dataFilters = datas.filters
    if (dataFilters.length) {
      dataFilters.forEach(data => {
        // elements INIT
        let listElement = L.DomUtil.create('li', 'list__element', this.tagEl);
        let textElement = L.DomUtil.create('span', 'element__text', listElement);
        let value = data;

        // Exception pour la gestion des couleurs dans les filtres
        if (typeof value === 'object') {
          listElement.dataset.value = value.name
          listElement.dataset.id = value.id

          textElement.innerHTML = capitalizeFirstLetter(value.name);

          if (value.icon !== null && value.icon !== '') {
            let icon = L.DomUtil.create('span', 'element__icon', listElement);
            icon.innerHTML = value.icon;
          }
          // events bind
          L.DomEvent.addListener(listElement, 'click', this.clickItem.bind({ context: this, element: listElement }));
          L.DomEvent.addListener(textElement, 'click', function (e) {
            L.DomEvent.stop(e);
            this.context.clickItem.call(this, e);
          }.bind({ context: this, element: listElement }));
        } else {
          // Exception pour les catégories de Filtres
          if (value.startsWith('optGroup__separator--')) {
            let splitedValue = value.split("--");
            if (splitedValue.length !== 1) {
              value = capitalizeFirstLetter(splitedValue[1]);
            } else {
              value = capitalizeFirstLetter(splitedValue[0]);
            }
            listElement.dataset.value = value.toLowerCase();
            listElement.classList.add("list__element--category");
            textElement.innerHTML = value;
            L.DomEvent.addListener(textElement, 'click', function (e) {
              L.DomEvent.stop(e);
            });
          } else {
            listElement.dataset.value = value;
            textElement.innerHTML = capitalizeFirstLetter(value);
            L.DomUtil.create('span', 'element__checkbox', listElement);
            // events bind
            L.DomEvent.addListener(listElement, 'click', this.clickItem.bind({ context: this, element: listElement }));
            L.DomEvent.addListener(textElement, 'click', function (e) {
              L.DomEvent.stop(e);
              this.context.clickItem.call(this, e);
            }.bind({ context: this, element: listElement }));
          }
        }
      });
    }
  },

  makeSubFiltersList: function (datas) {
    const dataSubfilters = datas.subfilters
    if (dataSubfilters.length) {
      dataSubfilters.forEach(data => {
        const subTypes = data.subTypes
        if (subTypes.length) {
          const subList = L.DomUtil.create('ul', 'subfilters__list', this.tagSubEl);
          subList.dataset.parent = data.parentId
          subTypes.forEach(subType => {
            const listElement = L.DomUtil.create('li', 'list__element subfilter', subList);
            const textElement = L.DomUtil.create('span', 'element__text', listElement);

            if (typeof subType === 'object') {
              listElement.dataset.value = sluggify(subType.label);
              listElement.dataset.parent = data.parentId
              textElement.innerHTML = capitalizeFirstLetter(subType.label);
              if (subType.svg) {
                const icon = L.DomUtil.create('span', 'element__icon', listElement);
                icon.innerHTML = subType.svg;
              }
              // events bind
              L.DomEvent.addListener(listElement, 'click', this.clickItem.bind({ context: this, element: listElement }));
              L.DomEvent.addListener(textElement, 'click', function (e) {
                L.DomEvent.stop(e);
                this.context.clickItem.call(this, e);
              }.bind({ context: this, element: listElement }));
            } else {
              listElement.dataset.value = value;
              textElement.innerHTML = capitalizeFirstLetter(value);
              L.DomUtil.create('span', 'element__checkbox', listElement);
              // events bind
              L.DomEvent.addListener(listElement, 'click', this.clickItem.bind({ context: this, element: listElement }));
              L.DomEvent.addListener(textElement, 'click', function (e) {
                L.DomEvent.stop(e);
                this.context.clickItem.call(this, e);
              }.bind({ context: this, element: listElement }));
            }
          })
        }
      })
    }
  },

  filtersCounter: function (filteredCount) {
    if (this.selectedTags.length > 0) {
      this.filterInfo.innerText = filteredCount.toString();
      this.filterInfo.style.display = "";
    } else {
      this.filterInfo.style.display = "none";
    }
  },

  clearFilters: function (e) {
    L.DomEvent.stop(e);

    // Création d'un array contenant tout les filtres
    const childrenFilters = this.tagEl.children
    const childrenSubFilters = this.tagSubEl.children
    const children = [...childrenFilters]
    if (childrenSubFilters.length) {
      [...childrenSubFilters].forEach(childrenSubFilter => {
        const childs = childrenSubFilter.children
        if (childs.length) {
          children.push(...childs)
        }
      })
    }

    // Nombre total de filtres
    const childCount = children.length

    this.selectedTags = [];

    for (let i = 0; i < childCount; i++) {
      let childCheckbox = children[i];
      if (childCheckbox) {
        this.uncheckItem(childCheckbox);
      }
    }

    if (this.options.filterOnEveryClick) {
      this.filter();
    }
  },

  hideFilters: function () {
    document.addEventListener('click', (e) => {
      if (!e.target.closest(`.${this._container.classList[0]}`)) {
        if (this._container.classList.contains('is-opened')) {
          this._container.classList.remove("is-opened");
        }
        if (this.tagSubEl.classList.contains('is-opened')) {
          this.tagSubEl.classList.remove("is-opened");
        }
      }
    }, false);
  },

  toggleFilters: function () {
    this._container.classList.toggle("is-opened");
    this.tagSubEl.classList.toggle("is-opened");
  },

  filter: function (withTags) {
    // Création d'un array contenant tout les filtres
    const childrenFilters = this.tagEl.children
    const childrenSubFilters = this.tagSubEl.children
    const children = [...childrenFilters]
    if (childrenSubFilters.length) {
      [...childrenSubFilters].forEach(childrenSubFilter => {
        const childs = childrenSubFilter.children
        if (childs.length) {
          children.push(...childs)
        }
      })
    }

    // Nombre total de filtres
    const childCount = children.length

    // Array qui vas contenir les filtres actifs
    this.selectedTags = []

    // Array qui vas contenir les id des filtres parents
    const parentIdArray = []
    const filtersTagsArray = []

    // Array qui vas contenir les sous filtres actifs
    const subFilterTagsArray = []

    if (withTags) {
      let acceptingTags = [];
      for (let i = 0; i < withTags.length; i++) {
        if (this.options.data.indexOf(withTags[i]) !== -1) {
          acceptingTags.push(withTags[i]);
        }
      }
      withTags = acceptingTags;
    }

    if (!withTags || !withTags.length) {
      for (let i = 0; i < childCount; i++) {
        let childCheckbox = children[i];
        if (childCheckbox && childCheckbox.dataset.checked) {
          if (!childCheckbox.classList.contains('subfilter')) {
            parentIdArray.push(childCheckbox.dataset.id)
            filtersTagsArray.push(childCheckbox.dataset.value)
          }
        }
      }

      for (let i = 0; i < childCount; i++) {
        let childCheckbox = children[i];
        if (childCheckbox && childCheckbox.dataset.checked) {
          if (childCheckbox.classList.contains('subfilter')) {
            if (parentIdArray.includes(childCheckbox.dataset.parent)) {
              subFilterTagsArray.push(childCheckbox.dataset.value)
            } else {
              this.uncheckItem(childCheckbox)
            }
          }
        }
      }
    } else {
      this.selectedTags = withTags;
    }


    // Filtre sur les sous-filtres s'il y en a
    if (filtersTagsArray.length) {
      if (subFilterTagsArray.length) {
        this.selectedTags = subFilterTagsArray
      } else {
        this.selectedTags = filtersTagsArray
      }
    } else {
      this.selectedTags = []
    }

    const filteredCount = this.layerSources.currentSource.hide.call(this, this.layerSources.currentSource);
    this.filtersCounter(filteredCount);
    if (this.options.onSelectionComplete && typeof this.options.onSelectionComplete === 'function') {
      this.options.onSelectionComplete.call(this, this.selectedTags);
    }

    // Filtre les magasins
    const tags = this.selectedTags;
    const itemSelector = this.options.storeItemSelector;
    if (tags.length && itemSelector) {
      // Construction d'une string de filtrage pour les magasins
      let tagString = ''
      tags.forEach(tag => {
        tagString += `:not(.${tag})`
      })

      // Affiche tout les magasins
      const allStoreItems = document.querySelectorAll(itemSelector)
      if (allStoreItems.length) {
        allStoreItems.forEach(store => {
          store.style.display = 'flex'
        })
      }
      // Cache les magasins filtrés
      const filteredStoreItems = document.querySelectorAll(`${itemSelector}${tagString}`)
      if (filteredStoreItems.length) {
        filteredStoreItems.forEach(store => {
          store.style.display = 'none'
        })
      }

      // Construction d'un array de sous-filtres selectionnés
      const subFiltersTagArray = []
      parentIdArray.forEach(id => {
        subFiltersTagArray.push(`.subfilters__wrapper .subfilters__list[data-parent="${id}"]`)
      })

      // Cache tout les sous-filtres
      const subFilters = document.querySelectorAll('.subfilters__wrapper .subfilters__list');
      if (subFilters.length) {
        subFilters.forEach(subfilter => {
          subfilter.style.display = 'none'
        })
      }

      // Affiche les sous-filtres correspondant aux catégories parentes
      if (subFiltersTagArray.length) {
        const filteredSubFilters = document.querySelectorAll(subFiltersTagArray.join());
        if (filteredSubFilters.length) {
          filteredSubFilters.forEach(filteredSubFilter => {
            filteredSubFilter.style.display = 'grid'
          })
        }
      }
    } else {
      // Affiche tout les magasins
      const allStoreItems = document.querySelectorAll(itemSelector)
      if (allStoreItems.length) {
        allStoreItems.forEach(store => {
          store.style.display = 'flex'
        })
      }

      // Cache tout les sous-filtres
      const subFilters = document.querySelectorAll('.subfilters__wrapper .subfilters__list');
      if (subFilters.length) {
        subFilters.forEach(subfilter => {
          subfilter.style.display = 'none'
        })
      }
    }
  },


  /**
   * DOM HTML Container maker
   * */
  addTo: function (map) {
    const options = this.options;
    const filtersContainer = document.querySelector(options.container);
    const subFiltersContainer = document.querySelector(options.subContainer);
    const data = options.data;
    let showFunction = this.toggleFilters;

    // Bind event to body
    this.hideFilters();

    // Creation du container principal
    this._container = L.DomUtil.create('div', 'filters__wrapper', filtersContainer);

    // Header
    this.filtersHeader = L.DomUtil.create('div', 'filters__header', this._container);
    L.DomEvent.addListener(this.filtersHeader, 'click', showFunction.bind(this));
    L.DomEvent.disableClickPropagation(this.filtersHeader);
    L.DomEvent.disableScrollPropagation(this.filtersHeader);
    this.filtersHeader.innerHTML = /* html */ `<span class="header__text" title="${this.options.header}">${this.options.header}</span>`;
    // Nombre de filtres
    this.filterInfo = L.DomUtil.create('span', 'header__counter', this.filtersHeader);
    this.filtersCounter(0);

    // Remplis la liste des filtres
    this.tagEl = L.DomUtil.create('ul', 'filters__list', this._container);
    if (data) {
      if (typeof data === 'function') {
        this.makeFiltersList(data());
      } else {
        this.makeFiltersList(data);
      }
    }

    // Remplis la liste des sous-filtres
    this.tagSubEl = L.DomUtil.create('div', 'subfilters__wrapper', subFiltersContainer);
    if (data) {
      if (typeof data === 'function') {
        this.makeSubFiltersList(data());
      } else {
        this.makeSubFiltersList(data);
      }
    }

    // Reset button
    if (this.options.clearText) {
      this.clearEl = L.DomUtil.create('li', 'list__element list__element--clear', this.tagEl);
      this.clearEl.title = `${this.options.clearText}`;
      this.clearEl.innerHTML = `${this.options.clearText}`;
      L.DomEvent.addListener(this.clearEl, 'click', this.clearFilters.bind(this));
    }
    return this;
  },


  /**
   * Marker cluster filter gestion
   * */
  enableMCG: function (mcgInstance) {
    this.registerCustomSource({
      name: 'mcg',
      source: {
        mcg: mcgInstance,
        hide: function (layerSource) {
          var releatedLayers = [];

          for (var r = 0; r < this.releatedFilterButtons.length; r++) {
            releatedLayers = releatedLayers.concat(this.releatedFilterButtons[r].getInvisibles());
          }

          var toBeRemovedFromInvisibles = [],
            i,
            toAdd = [];

          for (var i = 0; i < this.invisibles.length; i++) {
            if (releatedLayers.indexOf(this.invisibles[i]) == -1) {
              for (var j = 0; j < this.invisibles[i].options.tags.length; j++) {
                if (this.selectedTags.length == 0 || this.selectedTags.indexOf(this.invisibles[i].options.tags[j]) !== -1) {
                  //this.map.addLayer(this.invisibles[i]);
                  toAdd.push(this.invisibles[i]);
                  toBeRemovedFromInvisibles.push(i);
                  break;
                }
              }
            }
          }

          // Batch add into MCG
          layerSource.mcg.addLayers(toAdd);

          while (toBeRemovedFromInvisibles.length > 0) {
            this.invisibles.splice(toBeRemovedFromInvisibles.pop(), 1);
          }

          var removedMarkers = [];
          var totalCount = 0;

          if (this.selectedTags.length > 0) {
            //this.map.eachLayer(
            layerSource.mcg.eachLayer(
              function (layer) {
                if (layer && layer.options && layer.options.tags) {
                  totalCount++;
                  if (releatedLayers.indexOf(layer) == -1) {
                    var found = false;
                    for (var i = 0; i < layer.options.tags.length; i++) {
                      found = this.selectedTags.indexOf(layer.options.tags[i]) !== -1;
                      if (found) {
                        break;
                      }
                    }
                    if (!found) {
                      removedMarkers.push(layer);
                    }
                  }
                }
              }.bind(this)
            );

            for (i = 0; i < removedMarkers.length; i++) {
              //this.map.removeLayer(removedMarkers[i]);
              this.invisibles.push(removedMarkers[i]);
            }

            // Batch remove from MCG
            layerSource.mcg.removeLayers(removedMarkers);
          }

          return totalCount - removedMarkers.length;
        }
      }
    });

    this.layerSources.currentSource = this.layerSources.sources['mcg'];
  },
});

L.control.tagFilterButton = function (options) {
  return new L.Control.TagFilterButton(options);
};

const tagFilterButtonCustom = L.control.tagFilterButton;


export { tagFilterButtonCustom }
